import PuestoService from 'src/modules/puesto/puestoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'PUESTO_FORM';

const puestoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: puestoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await PuestoService.find(id);
      }

      dispatch({
        type: puestoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: puestoFormActions.INIT_ERROR,
      });

      getHistory().push('/puesto');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: puestoFormActions.CREATE_STARTED,
      });

      await PuestoService.create(values);

      dispatch({
        type: puestoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.puesto.create.success'),
      );

      getHistory().push('/puesto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: puestoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: puestoFormActions.UPDATE_STARTED,
      });

      await PuestoService.update(id, values);

      dispatch({
        type: puestoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.puesto.update.success'),
      );

      getHistory().push('/puesto');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: puestoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default puestoFormActions;
